export default __webpack_public_path__ + "static/media/a1.ce1d4bfc.png";